import { render, staticRenderFns } from "./view-toolbar-button.vue?vue&type=template&id=696a8fc2&scoped=true"
import script from "./view-toolbar-button.vue?vue&type=script&lang=js"
export * from "./view-toolbar-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696a8fc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/graphileon/graphileon/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('696a8fc2')) {
      api.createRecord('696a8fc2', component.options)
    } else {
      api.reload('696a8fc2', component.options)
    }
    module.hot.accept("./view-toolbar-button.vue?vue&type=template&id=696a8fc2&scoped=true", function () {
      api.rerender('696a8fc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue-view/view-toolbar-button.vue"
export default component.exports